// API abstraction for ລາຍການລໍຖ້າໂອນເງິນ COD.
// Both tabs (waiting + completed) flow through here.
// Flip USE_MOCK to false or set VUE_APP_USE_MOCK_COD=false to use the real backend.

import { COD_WAITING_LIST, COD_COMPLETED_LIST } from './mockData';

const USE_MOCK = (process.env.VUE_APP_USE_MOCK_COD ?? 'true') !== 'false';
const SIMULATED_LATENCY_MS = 250;
const wait = (data) => new Promise((resolve) => setTimeout(() => resolve(data), SIMULATED_LATENCY_MS));

let waitingList = COD_WAITING_LIST.map((r) => ({ ...r }));
let completedList = COD_COMPLETED_LIST.map((r) => ({ ...r }));

function paginate(list, page, perPage) {
  const start = (page - 1) * perPage;
  const data = list.slice(start, start + perPage);
  return {
    data,
    total: list.length,
    current_page: page,
    per_page: perPage,
    last_page: Math.max(1, Math.ceil(list.length / perPage)),
  };
}

function applyFilters(list, { search }) {
  if (!search) return list;
  const q = String(search).toLowerCase();
  return list.filter(
    (r) =>
      (r.name || '').toLowerCase().includes(q) ||
      (r.customer_tel || '').toLowerCase().includes(q)
  );
}

export function fetchCodWaitingList(http, params = {}) {
  if (USE_MOCK) {
    const page = params.page || 1;
    const perPage = params.per_page || 10;
    const filtered = applyFilters(waitingList, params);
    const totalAmount = waitingList.reduce((sum, r) => sum + (r.bill_count || 0), 0);
    return wait({ data: { ...paginate(filtered, page, perPage), total_amount: totalAmount } });
  }
  return http.get('v2/auth/corporate/cod-transfer/waiting', { params });
}

export function fetchCodCompletedList(http, params = {}) {
  if (USE_MOCK) {
    const page = params.page || 1;
    const perPage = params.per_page || 10;
    const filtered = applyFilters(completedList, params);
    const totalAmount = completedList.reduce((sum, r) => sum + (r.bill_count || 0), 0);
    return wait({ data: { ...paginate(filtered, page, perPage), total_amount: totalAmount } });
  }
  return http.get('v2/auth/corporate/cod-transfer/completed', { params });
}

// Confirms a waiting row + uploads the bank-transfer slip.
// Real backend will accept multipart/form-data; the mock just moves the row.
export function confirmAndUploadSlip(http, id, payload) {
  if (USE_MOCK) {
    const idx = waitingList.findIndex((r) => r.id === id);
    if (idx === -1) return wait({ data: null });
    const moved = {
      ...waitingList[idx],
      status: 'completed',
      slip_image_url: payload.slip_preview_url || 'https://via.placeholder.com/80x60/eef3ff/4b5161?text=Slip',
      transfer_date: payload.transfer_date,
      bill_count: Number(payload.bill_count) || waitingList[idx].bill_count,
    };
    waitingList.splice(idx, 1);
    completedList.unshift(moved);
    return wait({ data: moved });
  }
  const formData = new FormData();
  formData.append('slip', payload.slip_file);
  formData.append('bill_count', payload.bill_count);
  formData.append('transfer_date', payload.transfer_date);
  return http.post(`v2/auth/corporate/cod-transfer/waiting/${id}/confirm`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}
